import Column from '@components/Column';
import Header from '@components/Header';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import CommentSection from './components/CommentSection';
import DisposeDescription from './components/DisposeDescription';
import TerminationFooter from './components/TerminationFooter';

declare module '@stackflow/config' {
    interface Register {
        AccountTerminationActivity: {};
    }
}

const AccountTerminationActivity: ActivityComponentType<'AccountTerminationActivity'> = () => {
    const { t } = useTranslation('accountTermination');
    return (
        <AppScreen>
            <Column fullHeight>
                <Header title={t('header.title')}/>
                <Container as='main'
                    justify='space-between'
                    fullWidth
                    fullHeight>
                    <Column fullWidth>
                        <CommentSection/>
                        <DisposeDescription/>
                    </Column>
                    <TerminationFooter/>
                </Container>
            </Column>
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 0 20px 12px;
`;

export default AccountTerminationActivity;
